export default __webpack_public_path__ + "static/media/011-paddle.2ca2a395.png";